import { PushToUnassignedFilter } from 'generated/graphql';

export const firedUserStatuses = [
  { id: PushToUnassignedFilter.WithoutUnassigned, name: 'Не учитывать' },
  { id: PushToUnassignedFilter.WithUnassigned, name: 'Учитывать' },
  { id: PushToUnassignedFilter.UnassignedOnly, name: 'Только им' },
];
